import { TranslateFunction } from '../../../../hooks/useTranslate';

export const mainTableColumnTitles = (t: TranslateFunction): string[] => [
    t('table.columnsTitles.fullName'),
    t('table.columnsTitles.cuil'),
    t('table.columnsTitles.workPosition'),
    t('table.columnsTitles.sector'),
    t('table.columnsTitles.ingressDate'),
    t('table.columnsTitles.exposed'),
    t('table.columnsTitles.informationState'),
    t('table.columnsTitles.actions')
];

export const EXPOSITION_OPTIONS = [
    { id: 1, value: true, descripcion: 'Permanente' },
    { id: 2, value: false, descripcion: 'No Permanente' }
];

export const CARCINOGNIC_ITEM_INFORMATION_STATE = [
    {
        id: 1,
        nombre: 'Completa'
    },
    {
        id: 2,
        nombre: 'Incompleta'
    }
];
